import { useSubdomain } from '../contexts/UrlProvider'

export const useQrcodeUrlenerator = () => {
  const wsName = useSubdomain()
  return (id, recordId = null) => {
    if (recordId) {
      return `https://${wsName}.btime.io/qrcodes/${id}/recordId/${recordId}`
    }
    return `https://${wsName}.btime.io/qrcodes/${id}`
  }
}
